import { useQuery } from '@tanstack/react-query'
import { listBanners } from '../api/banners'
import { BANNER_PLACEMENT } from '../constants/api'
import { QUERY_KEYS } from '../constants/query'
import { toApiMessage } from '../helpers/api-error'
import { mapBannerCard, sortBySortOrder, type BannerCard } from '../helpers/mapContent'

type HomeBannersState = {
  heroBanners: BannerCard[]
  stripBanners: BannerCard[]
  loading: boolean
  error: string | null
}

export function useHomeBanners(): HomeBannersState {
  const heroQuery = useQuery({
    queryKey: QUERY_KEYS.banners(true, BANNER_PLACEMENT.hero),
    queryFn: () => listBanners(true, BANNER_PLACEMENT.hero),
  })
  const stripQuery = useQuery({
    queryKey: QUERY_KEYS.banners(true, BANNER_PLACEMENT.homeStrip),
    queryFn: () => listBanners(true, BANNER_PLACEMENT.homeStrip),
  })
  const error = heroQuery.error
    ? toApiMessage(heroQuery.error, 'Failed to load banners')
    : stripQuery.error
      ? toApiMessage(stripQuery.error, 'Failed to load banners')
      : null
  const loading =
    (heroQuery.isPending && !heroQuery.data) ||
    (stripQuery.isPending && !stripQuery.data)

  return {
    heroBanners: sortBySortOrder(heroQuery.data ?? []).map((row, index) =>
      mapBannerCard(row, index),
    ),
    stripBanners: sortBySortOrder(stripQuery.data ?? []).map((row, index) =>
      mapBannerCard(row, index),
    ),
    loading: loading && !error,
    error,
  }
}
